(() => {
  'use strict';

  if (window.__hadiyahSearchPlaceholderRotation) {
    window.__hadiyahSearchPlaceholderRotation.init(document);
    return;
  }

  const SELECTOR = '[data-animated-search-placeholder]';
  const TYPE_DELAY_MS = 90;
  const HOLD_DELAY_MS = 1600;
  const DELETE_DELAY_MS = 45;
  const BETWEEN_TERMS_DELAY_MS = 300;
  const initializedInputs = new WeakSet();
  const inputRestarters = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let resizeTimer = 0;

  const parseTerms = (input) =>
    String(input.dataset.searchPlaceholderTerms || '')
      .split('|')
      .map((term) => term.trim())
      .filter(Boolean);

  const initializeInput = (input) => {
    if (initializedInputs.has(input)) return;

    const prefix = String(input.dataset.searchPlaceholderPrefix || 'Search for').trim();
    const terms = parseTerms(input);
    if (!terms.length) return;

    initializedInputs.add(input);
    let termIndex = 0;
    let characterIndex = terms[0].length;
    let timer = 0;

    const placeholder = (term = '') => `${prefix}${term ? ` ${term}` : ''}`;
    const isVisible = () => !input.getClientRects || input.getClientRects().length > 0;
    const canAnimate = () =>
      !reducedMotion.matches &&
      !document.hidden &&
      document.activeElement !== input &&
      !input.value &&
      isVisible();
    const stop = () => {
      window.clearTimeout(timer);
      timer = 0;
    };
    const schedule = (callback, delay) => {
      stop();
      if (canAnimate()) timer = window.setTimeout(callback, delay);
    };

    const type = () => {
      if (!canAnimate()) return;
      const term = terms[termIndex];
      characterIndex += 1;
      input.placeholder = placeholder(term.slice(0, characterIndex));
      schedule(characterIndex >= term.length ? erase : type, characterIndex >= term.length ? HOLD_DELAY_MS : TYPE_DELAY_MS);
    };

    const erase = () => {
      if (!canAnimate()) return;
      const term = terms[termIndex];
      characterIndex = Math.max(0, characterIndex - 1);
      input.placeholder = placeholder(term.slice(0, characterIndex));

      if (characterIndex === 0) {
        termIndex = (termIndex + 1) % terms.length;
        schedule(type, BETWEEN_TERMS_DELAY_MS);
        return;
      }
      schedule(erase, DELETE_DELAY_MS);
    };

    const restart = () => {
      stop();
      if (reducedMotion.matches) {
        termIndex = 0;
        characterIndex = terms[0].length;
        input.placeholder = placeholder(terms[0]);
        return;
      }
      if (document.activeElement === input || input.value) {
        input.placeholder = placeholder();
        return;
      }

      characterIndex = terms[termIndex].length;
      input.placeholder = placeholder(terms[termIndex]);
      schedule(erase, HOLD_DELAY_MS);
    };

    input.addEventListener('focus', () => {
      stop();
      input.placeholder = placeholder();
    });
    input.addEventListener('blur', restart);
    input.addEventListener('input', () => {
      if (input.value) stop();
    });

    inputRestarters.set(input, restart);
    restart();
  };

  const restartAll = () => {
    inputRestarters.forEach((restart, input) => {
      if (input.isConnected === false) {
        inputRestarters.delete(input);
        return;
      }
      restart();
    });
  };

  const init = (root = document) => {
    if (root.matches?.(SELECTOR)) initializeInput(root);
    root.querySelectorAll?.(SELECTOR).forEach(initializeInput);
  };

  window.__hadiyahSearchPlaceholderRotation = { init };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('visibilitychange', restartAll);
  window.addEventListener('pageshow', restartAll);
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(restartAll, 120);
  });
  reducedMotion.addEventListener?.('change', restartAll);
})();
